import { BookmarkSwitch } from '@common/components/BookmarkSwitch';
import { Flex, Skeleton, Text } from '@radix-ui/themes';
import styles from './CollectionCard.module.css';
import { CollectionMetadata } from '@features/metadata/types';
import { useCollectionAssets } from '@features/Collection/hooks/useCollectionAssets';
import { Trans, useTranslation } from 'react-i18next';
import { Collection } from '@features/Collection';
import { FormattedDate } from '@common/components/FormattedDate';

interface CollectionCardOverlayProps {
    collection: Collection;
    metadata: CollectionMetadata;
}

export const CollectionCardOverlay = ({
    collection,
    metadata,
}: CollectionCardOverlayProps) => {
    useTranslation('common');
    const { id: collectionId, created } = collection;
    const { title } = metadata;
    const { itemCount, isLoading } = useCollectionAssets(
        { pageIndex: 0, pageSize: 1 },
        {
            collectionId,
        },
    );

    const date = new Date(created);

    return (
        <Flex
            className={styles.overlay}
            direction={'column'}
            justify={'between'}
            align={'start'}
            p={'3'}
            gap={'2'}
        >
            <Flex
                className={styles.detailsFlex}
                direction={'column'}
                gap={'1'}
                align={'start'}
            >
                <Text
                    size={'3'}
                    weight={'bold'}
                    align={'left'}
                    color={'gray'}
                    highContrast
                >
                    <Flex justify={'center'} gap={'1'}>
                        {title}
                    </Flex>
                </Text>

                <Skeleton loading={isLoading || !itemCount} minWidth={'80px'}>
                    <Text size={'1'} color={'gray'}>
                        {itemCount && (
                            <Trans
                                i18nKey={'asset'}
                                values={{ count: itemCount }}
                            />
                        )}
                    </Text>
                </Skeleton>
            </Flex>

            <Flex width={'100%'} align={'center'} justify={'between'}>
                <Text size={'1'} color='gray'>
                    <FormattedDate date={date} />
                </Text>
                <BookmarkSwitch collection={collection} />
            </Flex>
        </Flex>
    );
};
